/* Template: Desktop subnav
 ========================================================================== */

template.desktop_subnav_calc = () => {

  const $subMenu = $('.sub-menu');

  let containerWidth = $('.container-fluid').width(),
      containerY = $('.container-fluid').offset().left + containerWidth;

  // Loop though each sub menu to see if it appears outside of container and change position if it does
  $subMenu.each(function() {
    const subMenuWidth = $(this).outerWidth();
    const subMenuY  = $(this).offset().left + subMenuWidth;

    if(containerY < subMenuY) {
      $(this).css({
        'left' : 'auto',
        'right' : '0'
      });
    }
  });

};

template.desktop_subnav = function() {

  template.desktop_subnav_calc();

  let resizeEvent;
  $(window).on('resize', function(e) {
    clearTimeout( resizeEvent );
    resizeEvent = setTimeout( () => {
            template.desktop_subnav_calc();
          }, 250
    );
  });


};
